import { lightTheme } from '@/theme/light';
import { baseTheme } from '@/theme/index';
import { MOONTheme } from './IThemeConfig';

export const darkTheme: MOONTheme = {
    ...baseTheme,
    colors: {
        ...lightTheme.colors,
        background: '#363636'
    }
};
